export const getRoleNameForTracking = (availableRoles, roleId) =>
  availableRoles.find((role) => role.id === roleId)?.name.replaceAll(' ', '');
